export const normalizeModifierSelections = (selections = []) =>
  [...selections]
    .filter((selection) => Number(selection?.groupId) > 0 && Number(selection?.optionId) > 0)
    .map((selection) => ({
      groupId: Number(selection.groupId),
      optionId: Number(selection.optionId),
    }))
    .sort((left, right) => left.groupId - right.groupId || left.optionId - right.optionId);

export const buildDefaultSelectionMap = (modifierGroups = []) =>
  (modifierGroups || []).reduce((acc, group) => {
    const maxSelections = Number(group?.maxSelections || 1);
    const defaultOption = maxSelections === 1
      ? (group?.options || []).find((option) => option?.isDefault === true)
      : null;

    return {
      ...acc,
      [group.id]: defaultOption ? [defaultOption.id] : [],
    };
  }, {});

export const buildModifierSelectionKey = (selections = []) =>
  JSON.stringify(normalizeModifierSelections(selections));

export const calculateModifierTotal = (item, selections = []) => {
  const selectionMap = new Map(
    normalizeModifierSelections(selections).map((selection) => [`${selection.groupId}:${selection.optionId}`, true])
  );

  return (item?.modifierGroups || []).reduce((total, group) => {
    return total + (group.options || []).reduce((groupTotal, option) => {
      const optionKey = `${group.id}:${option.id}`;
      return groupTotal + (selectionMap.has(optionKey) ? Number(option.priceDelta || 0) : 0);
    }, 0);
  }, 0);
};

export const buildSelectedModifiers = (item, selections = []) => {
  const selectionMap = new Set(
    normalizeModifierSelections(selections).map((selection) => `${selection.groupId}:${selection.optionId}`)
  );

  return (item?.modifierGroups || []).flatMap((group) =>
    (group.options || [])
      .filter((option) => selectionMap.has(`${group.id}:${option.id}`))
      .map((option) => ({
        groupId: group.id,
        optionId: option.id,
        groupName: group.name,
        optionName: option.name,
        priceDelta: Number(option.priceDelta || 0),
      }))
  );
};

export const buildCartLineKey = ({ id, selectedModifierOptions = [], notes = '' }) => {
  const normalizedNotes = (notes || '').trim();
  const modifierKey = buildModifierSelectionKey(selectedModifierOptions);
  if (modifierKey === '[]' && !normalizedNotes) {
    return null;
  }
  return `${id}::${modifierKey}::${normalizedNotes}`;
};

export const formatModifierSummary = (modifiers = []) =>
  (modifiers || []).map((modifier) => modifier.optionName || modifier.name).join(', ');
